export const approvalItemStatus = {
    STATUS_PENDING: 'pending',
    STATUS_APPROVED: 'approved',
    STATUS_WITHDRAWN: 'withdrawn',
    STATUS_SUPERSEDED: 'superseded',
};

export const myTasksDefaultFilterOptions = {
    action: 'none',
};

export const requestsDefaultFilterOptions = {
    state: 'all',
};
